<template>
  <span class="mx3-share" ref="raiz" @click.stop>
    <button
      type="button"
      :class="btnClass"
      class="mx3-share-btn"
      v-mx3-tip="rotulo"
      :aria-label="rotulo"
      aria-haspopup="true"
      :aria-expanded="aberto ? 'true' : 'false'"
      @click.stop.prevent="alternar"
    >
      <i class="bi bi-share" aria-hidden="true"></i>
    </button>
    <!-- Menu fixo na tela (não é cortado pelos carrosséis/cards com overflow oculto) -->
    <div v-if="aberto" ref="menu" class="mx3-share-menu" role="menu" :style="estiloMenu" @click.stop>
      <button type="button" role="menuitem" @click="acao('whatsapp')"><i class="bi bi-whatsapp" aria-hidden="true"></i> WhatsApp</button>
      <button type="button" role="menuitem" @click="acao('copiar')"><i class="bi bi-link-45deg" aria-hidden="true"></i> {{ copiado ? "Link copiado!" : "Copiar link" }}</button>
      <button type="button" role="menuitem" v-if="nativo" @click="acao('nativo')"><i class="bi bi-box-arrow-up" aria-hidden="true"></i> Outros aplicativos</button>
    </div>
  </span>
</template>

<script>
// Botão "Compartilhar" reutilizável (card do produto e imagem da página de detalhes):
// WhatsApp, copiar link e compartilhamento nativo do aparelho (quando existir).
import mx3Tip from "@/utils/mx3Tip";

export default {
  name: "ShareButton",
  directives: { mx3Tip },
  props: {
    url: { type: String, default: "" }, // vazio = endereço da página atual
    title: { type: String, default: "Produto" },
    btnClass: { type: [String, Array, Object], default: "" },
    rotulo: { type: String, default: "Compartilhar" },
  },
  data() {
    return { aberto: false, copiado: false, estiloMenu: {} };
  },
  computed: {
    nativo() {
      return typeof navigator !== "undefined" && typeof navigator.share === "function";
    },
  },
  beforeDestroy() {
    this.fechar();
  },
  methods: {
    link() {
      return this.url || window.location.href;
    },
    alternar() {
      if (this.aberto) return this.fechar();
      const b = this.$refs.raiz.querySelector("button").getBoundingClientRect();
      const largura = 190;
      let esq = Math.min(Math.max(8, b.right - largura), window.innerWidth - largura - 8);
      let topo = b.bottom + 6;
      if (topo + 150 > window.innerHeight) topo = Math.max(8, b.top - 6 - 150);
      this.estiloMenu = { top: topo + "px", left: esq + "px", width: largura + "px" };
      this.aberto = true;
      // Leva o menu para o <body>: cards têm transform/overflow que cortam ou escondem um menu fixo.
      this.$nextTick(() => {
        if (this.$refs.menu) document.body.appendChild(this.$refs.menu);
      });
      window.setTimeout(() => {
        document.addEventListener("click", this.fora, true);
        window.addEventListener("scroll", this.aoRolar, true);
        window.addEventListener("resize", this.fechar);
        document.addEventListener("keydown", this.tecla);
      }, 0);
    },
    // Só a rolagem da página fecha o menu (os carrosséis rolam sozinhos e não devem fechá-lo).
    aoRolar(e) {
      const t = e && e.target;
      if (t === document || t === window || t === document.documentElement || t === document.body) this.fechar();
    },
    fora(e) {
      const dentro = (this.$refs.raiz && this.$refs.raiz.contains(e.target)) || (this.$refs.menu && this.$refs.menu.contains(e.target));
      if (!dentro) this.fechar();
    },
    tecla(e) {
      if (e.key === "Escape") this.fechar();
    },
    fechar() {
      this.aberto = false;
      this.copiado = false;
      document.removeEventListener("click", this.fora, true);
      window.removeEventListener("scroll", this.aoRolar, true);
      window.removeEventListener("resize", this.fechar);
      document.removeEventListener("keydown", this.tecla);
    },
    async acao(tipo) {
      const url = this.link();
      const nome = this.title || "Produto";
      if (tipo === "whatsapp") {
        window.open("https://wa.me/?text=" + encodeURIComponent(nome + " - " + url), "_blank", "noopener");
        this.fechar();
      } else if (tipo === "nativo") {
        try {
          await navigator.share({ title: nome, text: nome, url });
        } catch (e) {
          /* cancelado pelo usuário */
        }
        this.fechar();
      } else {
        let ok = false;
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(url);
            ok = true;
          }
        } catch (e) {
          ok = false;
        }
        if (!ok) {
          const ta = document.createElement("textarea");
          ta.value = url;
          ta.setAttribute("readonly", "");
          ta.style.position = "fixed";
          ta.style.opacity = "0";
          document.body.appendChild(ta);
          ta.select();
          try {
            ok = document.execCommand("copy");
          } catch (e) {
            ok = false;
          }
          document.body.removeChild(ta);
        }
        this.copiado = ok;
        if (ok) window.setTimeout(() => this.fechar(), 1400);
      }
    },
  },
};
</script>

<style lang="scss">
.mx3-share { display: inline-flex; }
.mx3-share-menu {
  position: fixed;
  z-index: 10050;
  padding: 6px;
  border-radius: 10px;
  background: var(--mx3-style-bg-card, #1c1e20);
  color: var(--default-color, #fff);
  border: 1px solid var(--mx3-style-border, rgba(128, 128, 128, 0.35));
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.35);
}
.mx3-share-menu button {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 10px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: inherit;
  font: inherit;
  font-size: 0.85rem;
  text-align: left;
  cursor: pointer;
}
.mx3-share-menu button:hover { background: color-mix(in srgb, currentColor 12%, transparent); }
</style>
